// vue-plugin.js
export default {
    install(Vue, options) {
      Vue.directive('appear', {
        inserted(el, binding) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 元素首次出现在视图窗口
                el.classList.add(binding.value);
                observer.unobserve(el); // 停止观察
              }
            });
          }, options);
   
          observer.observe(el); // 开始观察元素
   
          window.addEventListener('scroll', () => {
            // 滚动时重新检查元素是否在视图窗口
            observer.observe(el);
          });
        }
      });
    }
  };